// Error503Page.jsx
import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useNavigate } from "react-router";
import Lottie from "lottie-react";
import truckAnimation from '../../animations/truck.json'
export default function Error503Page({ onRetry }) {
//   const navigate = useNavigate();
  const shouldReduceMotion = useReducedMotion();

  const handleRetry = () => {
    if (typeof onRetry === "function") return onRetry();
    if (typeof window !== "undefined") window.location.reload();
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-b from-white via-[#F8FAFF] to-white py-12 px-6">
      <div className="max-w-4xl w-full rounded-2xl shadow-2xl border border-gray-100 bg-white overflow-hidden flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 p-10 flex flex-col items-center justify-center bg-white">
          <motion.div
            initial={{ scale: 0.98, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="flex flex-col items-center gap-6"
          >
            <div className="flex items-center gap-3">
             <img 
             src="icon-192.png"
             className="w-[40px] "
             ></img>
              <div className="text-special  font-semibold lg:text-lg text-sm">بارسرا</div>
            </div>
       
            {/* Big numeric code */}
            <div className="flex items-end gap-4">
              <motion.h1
                initial={{ x: -10, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="text-special font-extrabold lg:text-[72px] text-5xl leading-none"
              >
                ۵۰۳
              </motion.h1>
              <motion.div
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6 }}
                className="text-gray-500 lg:text-xl text-sm"
              >
                سرویس در دسترس نیست
              </motion.div>
            </div>
            <Lottie
        animationData={truckAnimation}
        loop={true}
        style={{ width: 300, height: 300 }}
      />



            <p className="text-gray-500 text-center leading-relaxed max-w-xs lg:text-base text-sm">
              به‌روزرسانی یا ترافیک بالا باعث قطع موقتی سرویس شده. تیم فنی ما درحال حل رفع مشکل است.
            </p>
          </motion.div>
        </div>

        <div className="w-full lg:w-1/2 p-10 bg-[#FBFDFF] flex flex-col justify-center gap-6">
          <div className="flex flex-col gap-4">
            <h2 className="text-[#0B3A7A] font-semibold lg:text-2xl text-lg">چند راهکار سریع</h2>

            <ul className="flex flex-col gap-3 text-gray-600">
              <li className="flex items-start gap-3">
                <span className="min-w-[8px] h-[8px] mt-2 rounded-full bg-[#0B3A7A]" />
                <span>چند دقیقه بعد دوباره سعی کنید — شاید مشکل موقتی باشد.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="min-w-[8px] h-[8px] mt-2 rounded-full bg-[#0B3A7A]" />
                <span>اگر هنوز مشکل حل نشده، با پشتیبانی تماس بگیرید.</span>
              </li>
            
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-2">
            <button
              onClick={handleRetry}
              className="flex-1 bg-[#0B3A7A] text-white py-3 rounded-lg font-medium shadow hover:brightness-110 transition"
              aria-label="بارگذاری مجدد"
            >
              بارگذاری مجدد
            </button>

      
          </div>

          <p className="text-xs text-gray-400 mt-4">
            شناسهٔ خطا: <span className="text-gray-600">503-{Math.random().toString(36).slice(2, 8)}</span>
          </p>
        </div>
      </div>
    </div>
  );
}
